import { Region } from "./commonInterfaces";

type RequestFn = (api: string, info: any) => Promise<any>;

const registry: Partial<Record<Region, RequestFn>> = {};

export const registerRequestByRegion = (region: Region, fn: RequestFn) => {
    registry[region] = fn;
};

export const getExportAxiosRequestByRegion = (region: Region): RequestFn => {
    return registry[region] ?? (() => Promise.resolve(undefined));
};
